export enum EDatabitCategoria {
  OUTSOURCING = 'Outsourcing',

  TI = 'TI',

  SISTEMAS = 'Sistemas'
}
